import { PublicClientApplication } from '@azure/msal-browser';

const microsoftClientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
const microsoftTenantId = process.env.REACT_APP_MICROSOFT_TENANT_ID;

export const microsoftAuthEnabled = Boolean(microsoftClientId && microsoftTenantId);

let msalInstance = null;
let msalInitializationPromise = null;

if (microsoftAuthEnabled) {
  msalInstance = new PublicClientApplication({
    auth: {
      clientId: microsoftClientId,
      authority: `https://login.microsoftonline.com/${microsoftTenantId}`,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  });
  // MSAL v4 requires explicit initialization before calling login/logout APIs.
  msalInitializationPromise = msalInstance.initialize();
}

async function ensureMicrosoftAuthReady() {
  if (!msalInstance) {
    throw new Error('Microsoft auth not configured');
  }

  if (msalInitializationPromise) {
    await msalInitializationPromise;
  }

  return msalInstance;
}

export async function microsoftLoginPopup() {
  const client = await ensureMicrosoftAuthReady();

  // Request the minimum identity scopes needed to match the corporate user email.
  const response = await client.loginPopup({
    scopes: ['openid', 'profile', 'email'],
    prompt: 'select_account',
  });

  return response.idToken;
}

export async function microsoftLogoutIfNeeded() {
  const client = await ensureMicrosoftAuthReady().catch(() => null);
  if (!client) return;

  const account = client.getActiveAccount() || client.getAllAccounts()[0];
  if (account) {
    await client.logoutPopup({ account });
  }
}
